// Update this version manually for each release
export const VERSION = '3.0.0';
